import React from 'react';
import { StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import IconPlus from 'design-system/icons/IconPlus';
import useColors from 'hooks/useColors';
import useAddAccount from 'hooks/useAddAccount';
const OverviewAddButton = ({ style, flex }) => {
    const addAccountModal = useAddAccount();
    const colors = useColors();
    return (<Button brandLight cards flex={flex} title="Add" onPress={addAccountModal} style={style} leftIcon={<IconPlus width={rem(10)} height={rem(10)} color={colors.text.textOnBrand}/>} leftIconContainerStyle={styles.iconLeft} containerStyle={styles.container}/>);
};
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: rem(10),
    },
    iconLeft: {
        paddingRight: rem(6),
    },
});
export default OverviewAddButton;
